import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
var ObservableInspService = /** @class */ (function () {
    function ObservableInspService() {
        this.usuario$ = new EventEmitter();
        this.direccion$ = new EventEmitter();
        this.folioDire$ = new EventEmitter();
        this.folioPredio$ = new EventEmitter();
        this.siglasId$ = new EventEmitter();
        this.tiposInsp$ = new EventEmitter();
        this.comentario$ = new EventEmitter();
        this.correo$ = new EventEmitter();
    }
    ObservableInspService.ngInjectableDef = i0.defineInjectable({ factory: function ObservableInspService_Factory() { return new ObservableInspService(); }, token: ObservableInspService, providedIn: "root" });
    return ObservableInspService;
}());
export { ObservableInspService };
